"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constants = exports.utils = exports.buttons = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

require("./skin.min.css");

var _index = _interopRequireDefault(require("!!raw-loader!./index.css"));

require("tinymce/themes/silver/theme");

require("tinymce/plugins/lists/plugin");

require("tinymce/plugins/paste/plugin");

var buttons = _interopRequireWildcard(require("./buttons"));

exports.buttons = buttons;

var utils = _interopRequireWildcard(require("./utils"));

exports.utils = utils;

var constants = _interopRequireWildcard(require("./constants"));

exports.constants = constants;

var _context = require("./context");

var _sanitize = require("./sanitize");

var _hotkey = require("./hotkey");

var _formats = _interopRequireDefault(require("./formats"));

var _constants2 = require("../../utils/constants");

var _parser = _interopRequireDefault(require("./parser"));

var _serializer = _interopRequireDefault(require("./serializer"));

var _LinkPopper = _interopRequireDefault(require("./components/LinkPopper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var $ = _tinymce["default"].dom.DomQuery;

function TinymceEditor(_ref, ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$linkDialogRef = _ref.linkDialogRef,
      linkDialogRef = _ref$linkDialogRef === void 0 ? null : _ref$linkDialogRef,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$debounced = _ref.debounced,
      debounced = _ref$debounced === void 0 ? true : _ref$debounced,
      _ref$focusEnd = _ref.focusEnd,
      focusEnd = _ref$focusEnd === void 0 ? false : _ref$focusEnd,
      _ref$enableInsertImag = _ref.enableInsertImage,
      enableInsertImage = _ref$enableInsertImag === void 0 ? true : _ref$enableInsertImag,
      _ref$defaultHTML = _ref.defaultHTML,
      defaultHTML = _ref$defaultHTML === void 0 ? '' : _ref$defaultHTML,
      _ref$onEditorChange = _ref.onEditorChange,
      onEditorChange = _ref$onEditorChange === void 0 ? _noop["default"] : _ref$onEditorChange,
      _ref$onUploadFiles = _ref.onUploadFiles,
      onUploadFiles = _ref$onUploadFiles === void 0 ? _noop["default"] : _ref$onUploadFiles,
      _ref$onLoadExternalIm = _ref.onLoadExternalImage,
      onLoadExternalImage = _ref$onLoadExternalIm === void 0 ? _noop["default"] : _ref$onLoadExternalIm,
      _ref$onLoadInlineImag = _ref.onLoadInlineImage,
      onLoadInlineImage = _ref$onLoadInlineImag === void 0 ? _noop["default"] : _ref$onLoadInlineImag,
      _ref$enableImageUrlTo = _ref.enableImageUrlToBlobConversion,
      enableImageUrlToBlobConversion = _ref$enableImageUrlTo === void 0 ? _noop["default"] : _ref$enableImageUrlTo,
      onInit = _ref.onInit,
      _ref$appearanceMode = _ref.appearanceMode,
      appearanceMode = _ref$appearanceMode === void 0 ? _constants2.themeMode.LIGHT : _ref$appearanceMode,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["disabled", "linkDialogRef", "autoFocus", "debounced", "focusEnd", "enableInsertImage", "defaultHTML", "onEditorChange", "onUploadFiles", "onLoadExternalImage", "onLoadInlineImage", "enableImageUrlToBlobConversion", "onInit", "appearanceMode"]);
  var rootRef = (0, _react.useRef)();

  var _useContext = (0, _react.useContext)(_context.EditorContext),
      editor = _useContext.editor,
      setEditor = _useContext.setEditor;

  var sanitizedHTML = (0, _react.useMemo)(function () {
    return (0, _sanitize.sanitize)(defaultHTML, {
      shouldRemoveDataURISchemeImageSource: !enableInsertImage
    });
  }, []);
  var contentRef = (0, _react.useRef)(sanitizedHTML);
  var initialAppearanceModeRef = (0, _react.useRef)(false);
  var appearanceModeRef = (0, _react.useRef)(appearanceMode);
  var unmountedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    appearanceModeRef.current = appearanceMode;
  }, [appearanceMode]);
  (0, _react.useEffect)(function () {
    if (!editor) return;

    if (!initialAppearanceModeRef.current) {
      initialAppearanceModeRef.current = true;
    } else {
      var body = editor.getBody();
      body.setAttribute('data-theme', appearanceMode);
      body.style['background-color'] = constants['THEME_BACKGROUND_COLORS'][appearanceMode];
      body.style['color'] = constants['THEME_COLORS'][appearanceMode];
      editor.resetContent(editor.getContent());
    }
  }, [editor, appearanceMode]);
  (0, _react.useEffect)(function () {
    //avoid load icons.js
    _tinymce["default"].IconManager.add('default', {
      icons: {}
    });

    _tinymce["default"].init(_objectSpread({
      readonly: disabled,
      target: rootRef.current,
      plugins: 'lists paste',
      allow_html_data_urls: false,
      init_instance_callback: function init_instance_callback(editor) {
        var body = editor.getBody();
        body.setAttribute('data-theme', appearanceMode);
        body.style['background-color'] = constants['THEME_BACKGROUND_COLORS'][appearanceMode];
        body.style['color'] = constants['THEME_COLORS'][appearanceMode];
        var container = editor.getContainer();
        container.style.flex = '1 1 auto';
        (0, _parser["default"])(editor, {
          onLoadInlineImage: onLoadInlineImage,
          onLoadExternalImage: onLoadExternalImage,
          appearanceModeRef: appearanceModeRef
        });
        (0, _serializer["default"])(editor, {
          appearanceModeRef: appearanceModeRef
        });
        editor.setContent(sanitizedHTML); //when initial the html may be parsed

        contentRef.current = editor.getContent();
        setEditor(editor);
        editor.undoManager.clear();
        editor.undoManager.add();
        editor.setDirty(false); // Set focus to end of editor
        // focusEnd && editor.selection.select(editor.getBody(), true)
        // editor.selection.collapse(false)

        autoFocus && editor.focus();
        var onChangeEvents = 'change keydown compositionend setcontent input';

        var handleChange = function handleChange(event) {
          if (unmountedRef.current) return;
          var editorHTML = editor.getContent();

          if (contentRef.current !== editorHTML) {
            onEditorChange(editorHTML);
            contentRef.current = editorHTML;
          }
        };

        editor.on(onChangeEvents, debounced ? (0, _debounce["default"])(handleChange, 500) : handleChange); //remove data-mce-bogus and keep br tag

        editor.on('NodeChange', function () {
          $('br[data-mce-bogus]', body).each(function (_, node) {
            return node.removeAttribute('data-mce-bogus');
          });
        });
        editor.on('PastePreProcess', function (event) {
          console.log('PastePreProcess', event);
        });
        editor.on('PastePostProcess', function (event) {
          console.log('PastePostProcess', event);
        });
        editor.on('PastePlainTextToggle', function (event) {
          console.log('PastePlainTextToggle', event);
        });
        editor.on('paste', function (event) {
          var files = event.clipboardData.items ? (0, _toConsumableArray2["default"])(event.clipboardData.items).filter(function (item) {
            return item.kind === 'file';
          }).map(function (item) {
            return item.getAsFile();
          }) : (0, _toConsumableArray2["default"])(event.clipboardData.files);

          if (!files.length) {
            return;
          }

          event.preventDefault();
          onUploadFiles(files, editor);
          return;
        });
        editor.on('drop', function (event) {
          if (!(event === null || event === void 0 ? void 0 : event.dataTransfer)) return;
          var files = event.dataTransfer.items ? (0, _toConsumableArray2["default"])(event.dataTransfer.items).filter(function (item) {
            return item.kind === 'file';
          }).map(function (item) {
            return item.getAsFile();
          }) : (0, _toConsumableArray2["default"])(event.dataTransfer.files);

          if (files.length === 0) {
            return;
          }

          event.preventDefault();
          onUploadFiles(files, editor);
        });
        editor.on('NodeChange', function (event) {
          (0, utils.autoResizeHandler)(editor);
        });
        onInit && onInit(editor); // if (height) {
        //   editor.dom.setStyle(editor.getContainer(), 'height', `${height}px`)
        //   editor.dom.setStyle(editor.getBody(), 'height', `${height}px`)
        // }
      },
      setup: function setup(editor) {
        editor.addCommand('customInsertLink', function () {
          return _hotkey.Hotkeys['Link'].command(editor, linkDialogRef);
        });
        Object.entries(_hotkey.Hotkeys).forEach(function (_ref2) {
          var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
              hotkey = _ref3[0],
              value = _ref3[1];

          if (value.type === _hotkey.SHORTCUT_TYPE.remove) {
            editor.shortcuts.remove(value.pattern);
            return;
          }

          if (hotkey === 'Link') {
            editor.addShortcut(value.pattern, hotkey, function () {
              return value.command(editor, linkDialogRef);
            });
          } else {
            editor.addShortcut(value.pattern, hotkey, function () {
              return value.command(editor);
            });
          }
        }); // Temp fix for unresponsive link context toolbar: https://github.com/tinymce/tinymce/issues/5097#issuecomment-663360737

        editor.on('PostRender', function () {
          var container = editor.getContainer();
          var uiContainer = document.querySelector('body > .tox.tox-tinymce-aux');
          container.parentNode.appendChild(uiContainer);
        });
      },
      relative_urls: false,
      remove_script_host: false,
      branding: false,
      contextmenu: false,
      custom_ui_selector: constants.TOOLBAR_CLASSNAME,
      elementpath: false,
      width: '100%',
      icons: '',
      preview_styles: false,
      menubar: false,
      toolbar: false,
      resize: false,
      skin: false,
      statusbar: false,
      content_css: false,
      content_style: _index["default"],
      visual: false,
      convert_fonts_to_spans: false,
      element_format: 'html',
      forced_root_block: 'div',
      remove_trailing_brs: false,
      entity_encoding: 'named',
      // Need to include this configuration if we are not editing node_modules
      valid_elements: _constants2.ALLOWED_TAGS.map(function (item) {
        return "".concat(item, "[*]");
      }).join(','),
      valid_styles: {
        '*': _constants2.ALLOWED_CSS_PROPERTIES.join(',')
      },
      formats: _formats["default"],
      valid_children: '+a[div|table]',
      browser_spellcheck: false,
      block_unsupported_drop: true,
      images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp',
      images_reuse_filename: true,
      object_resizing: 'img',
      // Temp fix to prevent conversion of base64 Url to blob Url
      images_dataimg_filter: enableImageUrlToBlobConversion,
      paste_webkit_styles: 'all',
      smart_paste: false
    }, props));
  }, []);
  (0, _react.useEffect)(function () {
    if (editor) {
      return function () {
        unmountedRef.current = true;
        editor.destroy();
      };
    }
  }, [editor]);
  (0, _react.useEffect)(function () {
    if (!editor) return;
    editor.mode.set(disabled ? 'readonly' : 'design');
  }, [editor, disabled]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getContent: function getContent() {
        return editor.getContent();
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: rootRef
  }), !!editor && /*#__PURE__*/_react["default"].createElement(_LinkPopper["default"], {
    linkDialogRef: linkDialogRef
  }));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(TinymceEditor);

exports["default"] = _default;
//# sourceMappingURL=index.js.map